import type { FaireProductEntity } from "../../entity_types/product";

export const p_kkq88ursme: FaireProductEntity = {
  token: "p_kkq88ursme",
  type: "product",
  name: "4.5“ Large Green Jade Elephant Figurine | Carved Stone Decor",
  brandToken: "b_gbfbknczne",
  brandName: "Crystal Deal· Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/968313b79986031f101a8e40557172e258e15b191efb79e96d9ba9f9dc0d93af.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ac1db693b191303bcb67bd0c26a5dcabd134fef94c18c31bd3a4272a53d75e25.jpeg",
    "https://cdn.faire.com/fastly/b9cdf84e781f28a1b79c2e454f9fd43806dde200b18b63cd79ea33de874fdf78.jpeg",
    "https://cdn.faire.com/fastly/d1eb30a7e954b7bc4203a35d433ebe5146702c2991cd65f32472f8416a7a8c4d.jpeg",
    "https://cdn.faire.com/fastly/b225ec81eb529c11ca3c7374e1b64c3926dc7b311a6e23db55c2427911be561d.jpeg",
  ],
  priceDollars: 20.79,
  description:
    'Hand-carved green jade elephant figurine with a smooth finish. Features natural green tones and solid stone weight. Suitable for home décor, desk display, or gift collections.\n\nNatural green jade stone\nHand-carved elephant shape\nSmooth polished surface\nDecorative stone figurine\nSold individually\n\nSize Approx. 10-12 cm (about 4.5")\nNatural variations in color and carving details are expected.',
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:15.963Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
